import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { ActivityLogsTableRow } from './ActivityLogsTableRow';

export const ActivityLogsChronological = observer(() => {
  const { activityLogsStore } = useWebsocketStore();
  const logsIdsList = activityLogsStore.logListInChronologicalOrder;
  return <tbody>
    {logsIdsList.map((id) => <ActivityLogsTableRow key={id} id={id}/>)}
  </tbody>;
});
